import { Form, Select } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { SelectProps } from 'antd/lib/select';
import * as React from 'react';
import { BaseFieldProps, WrappedFieldProps } from 'redux-form';
import { MapBoxPlace, PlaceSelectOptionValue } from 'logic/store/geolocation/geolocation.model';
import { FC } from 'react';
import { NamePath } from 'antd/lib/form/interface';

interface FormLocationSelectInputOwnProps extends FormItemProps {
  name: (NamePath | undefined) & string;
  disabled?: boolean;
  additionalAntFormItemStyles?: any;
  formItemClassName?: string;
  valuePlace?: MapBoxPlace | undefined;
  searchPlaces?: MapBoxPlace[] | undefined;
  placeholder?: string;
  onLocationContextChange?: (selectOption: PlaceSelectOptionValue | undefined) => void;
  onSearch: SelectProps<any>['onSearch'];
  onSelect: SelectProps<any>['onSelect'];
  onBlur: SelectProps<any>['onBlur'];
  options: JSX.Element[] | undefined;
  valueToDisplay: any;
}

export type FormLocationSelectInputProps = FormLocationSelectInputOwnProps &
  BaseFieldProps<FormLocationSelectInputOwnProps>;

export const FormLocationTemplateInput: FC<WrappedFieldProps & FormLocationSelectInputProps> = ({
  additionalAntFormItemStyles,
  formItemClassName,
  label,
  labelCol,
  wrapperCol,
  required,
  meta,
  input,
  placeholder,
  options,
  valueToDisplay,
  ...rest
}) => {
  const errorMessage = !!meta && meta.error;
  const showError = !!meta && meta.touched && !!meta.error;

  const renderSelect = () => {
    return (
      <Select<any>
        value={valueToDisplay}
        showSearch
        filterOption={false}
        showArrow={false}
        placeholder={placeholder}
        notFoundContent={placeholder}
        {...rest}
      >
        {options}
      </Select>
    );
  };

  return (
    <Form.Item
      label={label}
      style={additionalAntFormItemStyles}
      className={formItemClassName}
      required={required}
      validateStatus={showError ? 'error' : undefined}
      help={showError ? errorMessage : undefined}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      {renderSelect()}
    </Form.Item>
  );
};
